export default __webpack_public_path__ + "static/media/FeesHeader.c0f3e176.jpg";